import * as React from 'react';
import { Outlet } from 'react-router-dom';

import { AppSidebar } from './AppSidebar';

import { SidebarProvider } from './ui/sidebar';
import Navbar from './Nav/Navbar';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import UserLoginVideo from './LoginVideo/UserLoginVideo';
function AppLayout() {
  const { user } = useSelector((state: RootState) => state.user);
  const showVideo = localStorage.getItem('showLoginVideo') === 'true';

  return (
    <SidebarProvider>
      {showVideo && (
        <div className="fixed inset-0 z-50">
          <UserLoginVideo />
        </div>
      )}
      {user?.role === 'instructor' ? (
        <main className="w-full">
          <Navbar />
          <Outlet />
        </main>
      ) : (
        <>
          <AppSidebar />
          <main className="w-full">
            <Navbar />
            <Outlet />
          </main>
        </>
      )}
    </SidebarProvider>
  );
}

export default AppLayout;
